import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=13881ac9&scoped=true&"
import script from "./transport.vue?vue&type=script&lang=js&"
export * from "./transport.vue?vue&type=script&lang=js&"
import style0 from "./transport.vue?vue&type=style&index=0&id=13881ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13881ac9",
  null
  
)

export default component.exports